// True only on preview/local workspace surfaces. Used to show dev-only
// affordances (env banner, demo-account quick-logins) that must NEVER
// appear on the real customer-facing production domain.
export function isPreviewHost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return (
    h === "localhost" ||
    h === "127.0.0.1" ||
    h.endsWith(".preview.emergentagent.com") ||
    h.endsWith(".emergent.host")
  );
}
